export enum PaymentSteps {
    Tokenize,
    Authenticate,
    Authorize,
    CreateSalesOrder,
}